// extracted by mini-css-extract-plugin
module.exports = {"selectBlock":"DevicesPage_selectBlock__3kbKe","downloadButton":"DevicesPage_downloadButton__U2KZx"};